import { apiService } from "api/apiService";
import type {
  FilterResource,
  TransitionMeetingMyStudentsOverviewResource,
} from "api/generated";
import { myStudentsOverviewFromDto } from "meetings/advisory/api/mappers";
import type { TransitionMeetingMyStudentsOverview } from "meetings/advisory/types";

export const fetchLessonClassAdvisoryMeeting = async (
  scheduleId: string,
  params: Record<string, string> = {},
  signal?: AbortSignal,
): Promise<TransitionMeetingMyStudentsOverview> => {
  const url = `/api/my-lessongroups/${encodeURIComponent(scheduleId)}/advisory-meeting`;

  const { data } =
    await apiService.get<TransitionMeetingMyStudentsOverviewResource>(url, {
      params,
      signal,
    });

  return myStudentsOverviewFromDto(data);
};

export const fetchLessonClassAdvisoryMeetingFilters = async (
  scheduleId: string,
  signal?: AbortSignal,
): Promise<FilterResource[]> => {
  const url = `/api/my-lessongroups/${encodeURIComponent(scheduleId)}/advisory-meeting/filters`;

  const {
    data: { data: filters },
  } = await apiService.get<{ data: FilterResource[] }>(url, { signal });

  return filters;
};
